module.exports = __webpack_public_path__ + "img/Utilitario.29502eee.png";